<template>
  <div class=" is-fullwidth">
      <div class="card">
          <div class="card-content">
                <div class="field">
                    <label class="label">PO Number</label>
                    <div class="control">
                        <input class="input" type="text" v-model="ponumber" autofocus>
                    </div>
                </div>

                <div class="field ">
                    <div class="control">
                        <button class="button is-success" @click="viewOrder()">Search</button>
                    </div>
                    
                </div>
            </div>
    </div>
    <br />
    <div class="card " v-if="order.orderID > 0 && loading == false">
          <div class="card-content">
              <table class="table is-fullwidth" v-if="order.logs.length > 0">
                  <thead>
                    <tr>
                            <th>Action</th>
                            <th>User (Who Peformed the Action)</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in order.logs" :key="row.id">
                            <td>{{ row.text }}</td>
                            <td>{{ row.firstname }} {{row.surname}}</td>
                            <td>{{ row.date }}</td>
                        </tr>
                    </tbody>
                </table>
                
            </div>
    </div>
    <br />
    <div class="card ">
          <div class="card-content">
                <div class="notification is-info" v-if="order.orderID == 0 && loading == false">
                   Enter a PO Number above to search for an order
                </div>
               
                <div class="notification is-warning" v-if="loading == true">
                   Seaching for your order ...
                </div>

                <div class="" v-if="order.orderID > 0 && loading == false">
                   <div class="field">
                    <label class="label">PO Number</label>
                        <div class="columns">
                            <div class="control column">
                                <input class="input" type="text" v-model="order.ponumber" readonly disabled>
                            </div>
                            <div class=" column">
                                <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-warning">View Order</button></a>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Order Date</label>
                        <div class="control">
                            <input class="input" type="text" v-model="order.orderdate" readonly disabled>
                        </div>
                    </div>
                     <div class="field">
                        <label class="label">Artwork</label>
                        <div class="control">
                            <div class="buttons has-addons ">
                              <button class="button is-small " :class="[order.artwork_new== 1 ? 'is-success' : '']" :disabled="working==true" @click="updateArtwork(1,0)">New</button>
                              <button class="button is-small " :class="[order.artwork_repeat== 1 ? 'is-warning' : '']" :disabled="working==true" @click="updateArtwork(0,1)">Repeat</button>
                              <button class="button is-small " :class="[order.artwork_repeat== 0 && order.artwork_new== 0 ? 'is-info' : '']" :disabled="working==true" @click="updateArtwork(0,0)">None</button>
                            </div>
                        </div>
                    </div>
                     <div class="field">
                            <label class="label">Digital Print Locations</label>
                        </div>

                        <div class="field">
                            <div class="is-flex is-align-items-center">
                                <label class="label" style="margin-bottom: 0; margin-right: 1rem; min-width: 200px; font-weight: normal;">Paper Print Location</label>
                                <div class="control">
                                    <div class="buttons has-addons">
                                        <button class="button is-small" @click="updatePrintLocation(row.id)" :disabled="working==true" :class="{'is-success' : order.print_location_id==row.id}" v-for="row in locations" :key="row.id">{{ row.name }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="field">
                            <div class="is-flex is-align-items-center">
                                <label class="label" style="margin-bottom: 0; margin-right: 1rem; min-width: 200px; font-weight: normal;">Fabric Rolls Location</label>
                                <div class="control">
                                    <div class="buttons has-addons">
                                        <button class="button is-small" @click="updateFabricRollsLocation(row.id)" :disabled="working==true" :class="{'is-success' : order.fabric_print_location_id==row.id}" v-for="row in locations" :key="row.id">{{ row.name }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="field">
                            <div class="is-flex is-align-items-center">
                                <label class="label" style="margin-bottom: 0; margin-right: 1rem; min-width: 200px; font-weight: normal;">Gerber Cutting Location</label>
                                <div class="control">
                                    <div class="buttons has-addons">
                                        <button class="button is-small" @click="updateGerberCuttingLocation(row.id)" :disabled="working==true" :class="{'is-success' : order.gerber_print_location_id==row.id}" v-for="row in locations" :key="row.id">{{ row.name }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <div class="field">
                        <label class="label">Makeup Location</label>
                        <div class="control">
                            <div class="buttons has-addons ">
                                <button class="button is-small " :disabled="working==true" :class="{'is-success' : order.makeup_location_id==row.id}" @click="updateMakeupLocation(row.id)" v-for="row in makeuplocations" :key="row.id">{{ row.name }}</button>
                            </div>
                        </div>
                    </div>
                    <div class="field" style="display:none">
                        <label class="label">Reset Order</label>
                        <div class="control">
                            <div class="buttons has-addons ">
                                <button class="button is-small is-danger" :disabled="working==true"  @click="resetOrder()" >Reset Order (For Testing Only)</button>
                            </div>
                        </div>
                    </div>
                </div>

                
                
            </div>
    </div>
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
     mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      order: {orderID: 0},
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading:false,
      locations: [],
      makeuplocations: [],
      ponumber: '',
      ASP_URL : process.env.VUE_APP_ASP_URL,
    }
  },
   methods: {
      async viewOrder() {
        if(this.ponumber != '' && this.ponumber != null)
        {
          this.loading=true
          OrderService.getOrderByPONumber(this.accessToken, this.ponumber, "")
          .then(
            (orders => {
                if(orders.length > 0)
                {
                      this.$set(this, "order", orders[0]);
                }
              this.loading=false
            }).bind(this)
          );
        }
      },
      
      getPONumber() {
        let urlParams = new URLSearchParams(window.location.search);
        let urlPONumber = urlParams.get('ponumber');
        this.ponumber = urlPONumber
      },
    
    async updateMakeupLocation(makeup_location_id) {
        alert("This no longer updates the makeup location. Please use the specific screen in the blue system to do this")
            console.log(makeup_location_id)
        /*
        this.working = true

        var order_id = this.order.orderID

        var formdata = { 
            _method: 'patch',
             makeup_location_id: makeup_location_id
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            this.order.makeup_location_id = makeup_location_id
            this.working = false
            //console.log(response)
            alert("The makeup location for this order has been updated")
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
        */
    },
    async updateArtwork(artwork_new, artwork_repeat) {
        this.working = true

        var order_id = this.order.orderID

        var formdata = { 
            _method: 'patch',
             artwork_new: artwork_new,
             artwork_repeat: artwork_repeat
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            this.order.artwork_new = artwork_new
            this.order.artwork_repeat = artwork_repeat
            this.working = false
            //console.log(response)
            alert("The artwork type for this order has been updated")
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async resetOrder() {
        this.working = true

        if(confirm('Are you sure you want to reset all the values for this order ?'))
        {

          var order_id = this.order.orderID

          var formdata = { 
              _method: 'patch',
              artwork_new: 0,
              artwork_repeat: 0,
              artwork_finished: 0,
              artwork_completed: 0,
              artwork_printed_paper: 0,
              artwork_printed_rolls: 0,
              digital_print_cutting: 0,
              completed: 0,
              print_location_id: 0,
              makeup_location_id: 0,
              artworker_user_id: 0,
              artwork_gemini: 0,
              artwork_standard: 0,
              artwork_nested: 0,
          }; 

          OrderService.updateOrder(this.accessToken, order_id, formdata)
          .then(() => {
              this.order.artwork_new = 0;
              this.order.artwork_repeat = 0;
              this.order.artwork_finished = 0;
              this.order.artwork_completed = 0;
              this.order.artwork_printed_paper = 0;
              this.order.artwork_printed_rolls = 0;
              this.order.digital_print_cutting = 0;
              this.order.completed = 0;
              this.order.print_location_id = 0;
              this.order.makeup_location_id = 0;
              this.order.artworker_user_id = 0;
              this.order.artwork_gemini = 0;
              this.order.artwork_standard = 0;
              this.order.artwork_nested = 0;


              this.working = false
              //console.log(response)
              alert("The order has been reset")
          }).catch((error) => {
            alert("Something went wrong and the order has not been updated. Please reload and try again")
              console.log("Error:" + JSON.stringify(error.response.data));
              this.working = false
          });
        }
        else{
          this.working = false
        }
    }
    
  },
  computed : {
     
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getLocations();
           this.getMakeupLocations();
            this.viewOrder()
        });
  },
 
  mounted() {
    this.getPONumber()
     
  },
  watch: {
    '$route'() {
      
    },
    
  }
}


</script>

